var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{staticClass:"header-logo",attrs:{"to":_vm.localePath('/')}},[_c('SfImage',_vm._b({staticClass:"sf-header__logo-img"},'SfImage',_vm.logoProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }